import axios from "../config/axiosInstance";

export const categoryService = {
  getAllCategories: async () => {
    return await axios.get(`/categories/get-all-categories`);
  },

  getCategoryById: async (categoryId) => {
    return await axios.get(`/categories/get-category-by-id/${categoryId}`);
  },

  createCategory: async (categoryData) => {
    return await axios.post(`/categories/create-category`, categoryData);
  },

  updateCategory: async (categoryId, categoryData) => {
    return await axios.put(`/categories/update-category/${categoryId}`, categoryData);
  },

  deleteCategory: async (categoryId) => {
    return await axios.delete(`/categories/delete-category/${categoryId}`);
  },

  getCategoriesWithTourCount: async () => {
    return await axios.get(`/categories/get-categories-with-tour-count`);
  },
};
